import React from 'react';
import PropTypes from 'prop-types';
import RcSwitch from 'rc-switch';
import './styles.scss';

const Switch = ({ className = '', dataTest = '', ...props }) => (
    <div className={`fm-field-switch ${className}`}>
        <RcSwitch {...props} data-test={dataTest} />
    </div>
);

Switch.propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    className: PropTypes.string,
    dataTest: PropTypes.string,
};

export default Switch;
